import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function AddSite() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    url: '',
    wp_username: '',
    wp_app_password: '',
    gsc_property: '',
    ga4_property_id: '',
    country: 'IL',
    language: 'he',
  });
  const [localeOptions, setLocaleOptions] = useState({ countries: [], languages: [] });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [createdSite, setCreatedSite] = useState(null);

  useEffect(() => {
    api.getSiteLocaleOptions().then(setLocaleOptions).catch(() => {});
  }, []);

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name || !form.url) {
      setError('שם וכתובת הם שדות חובה');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const site = await api.createSite(form);
      setCreatedSite(site);
    } catch (err) {
      setError(err.message);
    }
    setSaving(false);
  }

  async function handleConnectGoogle() {
    try {
      const data = await api.getGoogleLoginUrl(createdSite.id);
      window.location.href = data.auth_url;
    } catch (err) {
      alert(err.message);
    }
  }

  if (createdSite) {
    return (
      <>
        <div className="page-header">
          <div>
            <div className="page-title">האתר נוצר בהצלחה!</div>
            <div className="page-subtitle">{createdSite.name} - {createdSite.url}</div>
          </div>
        </div>

        <div className="form-card" style={{ textAlign: 'center', padding: '40px 24px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#10003;</div>
          <h3 style={{ marginBottom: '8px', fontSize: '18px' }}>האתר {createdSite.name} נוסף למערכת</h3>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '24px' }}>
            כדי לשלוף נתוני Search Console ו-Analytics, חבר את חשבון Google שיש לו גישה לאתר
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-primary" onClick={handleConnectGoogle} style={{ padding: '12px 24px' }}>
              חבר חשבון Google (SC + GA4)
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/sites/' + createdSite.id)}>
              דלג - אחבר אחר כך
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <button className="back-btn" onClick={() => navigate('/')}>
        &rarr; חזרה לרשימה
      </button>

      <div className="page-header">
        <div>
          <div className="page-title">הוספת אתר חדש</div>
          <div className="page-subtitle">הזן את פרטי האתר וחיבור WordPress</div>
        </div>
      </div>

      <form className="form-card" onSubmit={handleSubmit}>
        {error && (
          <div style={{
            background: 'rgba(239,68,68,0.1)',
            border: '1px solid rgba(239,68,68,0.3)',
            borderRadius: '6px',
            padding: '10px 14px',
            color: 'var(--red)',
            fontSize: '13px',
            marginBottom: '16px',
          }}>
            {error}
          </div>
        )}

        <div className="form-group">
          <label className="form-label">שם האתר *</label>
          <input className="form-input" name="name" value={form.name} onChange={handleChange} placeholder="לדוגמה: נטע גינון" />
        </div>

        <div className="form-group">
          <label className="form-label">כתובת (URL) *</label>
          <input className="form-input ltr" name="url" value={form.url} onChange={handleChange} placeholder="https://www.example.co.il" />
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <div className="form-group" style={{ flex: 1 }}>
            <label className="form-label">מדינת חיפוש</label>
            <select className="form-input" name="country" value={form.country} onChange={handleChange}>
              {localeOptions.countries.length === 0 && <option value="IL">ישראל</option>}
              {localeOptions.countries.map(o => <option key={o.code} value={o.code}>{o.label}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label className="form-label">שפת חיפוש</label>
            <select className="form-input" name="language" value={form.language} onChange={handleChange}>
              {localeOptions.languages.length === 0 && <option value="he">עברית</option>}
              {localeOptions.languages.map(o => <option key={o.code} value={o.code}>{o.label}</option>)}
            </select>
          </div>
        </div>
        <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '-8px', marginBottom: '16px' }}>
          בדיקות המיקום, נפחי החיפוש ונתוני Search Console יימדדו בגוגל של המדינה הזו ובשפה הזו
        </div>

        <div className="form-group">
          <label className="form-label">WordPress Username</label>
          <input className="form-input ltr" name="wp_username" value={form.wp_username} onChange={handleChange} placeholder="admin" />
        </div>

        <div className="form-group">
          <label className="form-label">WordPress Application Password</label>
          <input className="form-input ltr" name="wp_app_password" value={form.wp_app_password} onChange={handleChange} placeholder="xxxx xxxx xxxx xxxx xxxx xxxx" />
        </div>

        <div className="form-group">
          <label className="form-label">Search Console Property</label>
          <input className="form-input ltr" name="gsc_property" value={form.gsc_property} onChange={handleChange} placeholder="https://www.example.co.il/" />
        </div>

        <div className="form-group">
          <label className="form-label">GA4 Property ID</label>
          <input className="form-input ltr" name="ga4_property_id" value={form.ga4_property_id} onChange={handleChange} placeholder="properties/123456789" />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'שומר...' : 'הוספת אתר'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/')}>
            ביטול
          </button>
        </div>
      </form>
    </>
  );
}
